
"use client";
import React from "react";
import { fetchFeaturedProducts } from "../../lib/fetchData";
import ProductList from "../all-products";
import { Link } from "react-router-dom";
//
export default  function FeaturedProducts() {
const [products, setProducts] = React.useState<any>([]); 
  const listFeatured =  () => {
  fetchFeaturedProducts({ limit: 6 }).then((res) => {  
  console.log("Prods::",res)
 setProducts(res.status ? res.data : []);
  });
  } 

  React.useEffect(() => {
    listFeatured();
  }, []); 
  return (
    <section className="page-width">
      <div className="after-detail">
        <h2 className="text-center">Explore Our Products</h2>
      </div>
      <div className="page-body py0">
        <ProductList
          is_shadowed
          is_featured={true}
          is_admin={false}
          products={products}
        />

        <div className="explore-link py30">
          <Link to="/products">View All Products &rarr; </Link>
        </div>
      </div>
    </section>
  );
}
